<!-- StatisticsModal.vue -->
<template>
  <div class="modal-container">
    <img
      src="images/close.svg"
      class="close"
      @click="resetModal"
      role="button"
      aria-label="Close"
      alt="X to close modal"
      title="Close"
    />
    <div class="modal-content">
      <div class="modal-main">
        <knot-carousel :use-slide-names="true">
          <template v-slot:today>
            <div class="centered-text stats-flex">
              <div>
                <img
                  src="images/spiral.svg"
                  class="stats-img"
                  alt="spiral"
                  title="Knotilus Spiral"
                />
              </div>
              <template v-if="puzzleCompleted">
                <h2>Congrats!</h2>
                <h2 class="important-note">
                  {{ displayDate }} | No. {{ puzzleNumber }}
                </h2>
                <h2 class="important-note">
                  Level {{ status.level }} | {{ status.mode }} Mode
                </h2>
                <div class="stats-box">
                  <template
                    v-for="(stat, index) in todayInfo"
                    :key="stat.label"
                  >
                    <div
                      class="stats-cell break"
                      v-if="statsBreak(index)"
                    ></div>
                    <div class="stats-cell">
                      <div class="stats-value">{{ stat.value }}</div>
                      <div class="stats-label">{{ stat.label }}</div>
                    </div>
                  </template>
                </div>
              </template>
              <template v-else>
                <p class="important-note">
                  The puzzle for {{ displayDate }} has not yet been completed
                </p>
              </template>
              <div class="stats-box" v-if="hasOverallStatistics">
                <div
                  v-for="stat in overallStatistics"
                  class="stats-cell"
                  :key="stat.label"
                >
                  <div class="stats-value">{{ stat.value }}</div>
                  <div class="stats-label">{{ stat.label }}</div>
                </div>
              </div>
              <template v-if="puzzleCompleted && !isArchivePlay">
                <h2>Time Until Next Puzzle</h2>
                <div>
                  <knot-timer
                    :elapsedTimeFormater="elapsedTimeFormater"
                    :referenceTime="nextPuzzleDay"
                    size="28px"
                  ></knot-timer>
                </div>
              </template>

              <div class="centered-objects" v-if="puzzleCompleted">
                <button
                  class="single-button"
                  @click="setModal('Settings', 'Archive')"
                >
                  Archive
                </button>
              </div>
              <div
                class="centered-objects"
                v-if="puzzleCompleted && !isArchivePlay"
              >
                <div class="button-group">
                  <button class="left share" @click="shareResult">
                    Share
                    <div class="icon" v-html="getSVG('SHARE')"></div>
                  </button>
                  <button class="right feedback" @click="navigateToSurvey">
                    <div class="icon" v-html="getSVG('FEEDBACK')"></div>

                    Feedback
                  </button>
                </div>
              </div>

              <template v-if="partnerGamesActions.length !== 0">
                <h2 class="important-note">Games We Love</h2>
                <div class="centered-objects">
                  <multi-action-button
                    :dynamicActions="partnerGamesActions"
                    :staticAction="moreStaticAction"
                    dynamic-side="left"
                    @set-modal="setModal"
                    :slide-interval="5000"
                    :randomized="true"
                    v-if="puzzleCompleted"
                  >
                  </multi-action-button>
                </div>
              </template>
              <template v-if="spotlights.length !== 0">
                <spotlight-links
                  :slide-interval="7500"
                  :spotlights="spotlights"
                  @setModal="setModal"
                ></spotlight-links>
              </template>
            </div>
          </template>
          <template v-slot:statistics>
            <template v-if="saveProgress">
              <div class="centered-text stats-flex">
                <template v-if="hasFavoriteStatistics">
                  <h2>Favorite Options</h2>
                  <div class="stats-box">
                    <div
                      v-for="stat in favoriteStatistics"
                      class="stats-cell"
                      :key="stat.label"
                    >
                      <div class="stats-value">{{ stat.value }}</div>
                      <div class="stats-label">{{ stat.label }}</div>
                    </div>
                  </div>
                </template>
                <h2 class="centered-objects">
                  <div class="knotilus-logo">
                    <img
                      src="images/knotilus-logo.webp"
                      title="Knotilus Daily Puzzle Game"
                      alt="Knotilus"
                    />
                    <knot-select
                      :items="levels"
                      @select-item="levelSelected"
                      :defaultItem="level"
                      id="level"
                      :activeSelect="activeSelect"
                    ></knot-select>
                  </div>
                  Statistics
                </h2>
                <transition-group
                  name="fade"
                  tag="div"
                  class="lvl-stats-container"
                >
                  <div
                    v-for="(levelStatistics, lvl) in selectedLevelStatistics"
                    :key="lvl"
                  >
                    <div class="stats-box" v-if="hasLevelStatistics">
                      <template
                        v-for="stat in levelStatistics"
                        :key="stat.label"
                      >
                        <div class="stats-cell">
                          <div class="stats-value">{{ stat.value }}</div>
                          <div class="stats-label">
                            {{ stat.label }}
                          </div>
                        </div>
                      </template>
                    </div>
                    <div class="centered stats-box two-row" v-else>
                      <div>
                        <p>
                          There aren't any
                          <strong>Knotilus {{ level }}</strong> Statistics
                        </p>
                        <p>Yet...</p>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </div>
            </template>
            <template v-else>
              <p class="important-note centered-text">
                To track your progress and view overall stats enable
                <strong>Save Progress</strong> in Settings.
              </p>
              <div class="centered-objects">
                <button
                  class="single-button archive"
                  @click="setModal('Settings', 'General')"
                >
                  Settings
                </button>
              </div>
              <a
                @click="setModal('Help', 'privacy')"
                class="important-note centered-text"
                >Privacy and Data Usage Notice
              </a>
            </template>
            <div class="centered-objects" style="margin-top: 3vh">
              <button class="single-button" @click="setModal('Leaderboard')">
                <div class="icon" v-html="getSVG('LEADERBOARD')"></div>
                Leaderboard
              </button>
            </div>
            <div class="centered-objects" v-if="puzzleCompleted">
              <button class="single-button" @click="setModal('Benchmarks')">
                <div class="icon" v-html="getSVG('BENCHMARKS')"></div>
                Benchmarks
              </button>
            </div>
          </template>
        </knot-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { MODE, SVGS } from "../types.js";
import SpotlightLinks from "./SpotlightLinks.vue";
export default {
  components: { SpotlightLinks },
  name: "StatisticsModal",
  props: {
    saveProgress: {
      type: Boolean,
      required: true,
    },
    resetModal: {
      type: Function,
      required: true,
    },
    statistics: {
      type: Object,
      required: true,
    },
    status: {
      type: Object,
      required: true,
    },
    puzzleCompleted: {
      type: Boolean,
      required: true,
    },
    elapsedTimeFormater: {
      type: Function,
      required: true,
    },
    levels: {
      type: Array,
      required: true,
    },
    puzzleTime: {
      type: Number,
      required: true,
    },
    puzzleNumber: {
      type: Number,
      required: true,
    },
    foundSequencesStr: {
      type: String,
      required: true,
    },
    displayDate: {
      type: String,
      required: true,
    },
    isArchivePlay: {
      type: Boolean,
      required: true,
    },
    defaultLevel: {
      type: Number,
      required: true,
    },
    partnerGamesActions: {
      type: Array,
      required: true,
    },
    moreStaticAction: {
      type: Object,
      required: true,
    },
    spotlights: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      level: null,
      surveyLink: `${process.env.VUE_APP_API_BASE_URL}/survey/`,
      activeSelect: "",
    };
  },
  mounted() {
    this.level = this.defaultLevel;
  },
  methods: {
    navigateToSurvey() {
      window.open(this.surveyLink, "_blank");
    },
    statsBreak(index, perRow = 3) {
      return index % perRow == 0 && index !== 0;
    },
    levelSelected(level) {
      this.level = level;
    },
    shareResult() {
      this.$emit("share");
    },
    setModal(key, slide) {
      this.$emit("set-modal", key, slide);
    },
    toBenchmarks() {
      this.$emit("to-archive");
    },
    getSVG(key) {
      return SVGS[key];
    },
  },
  computed: {
    statisticsAvailable() {
      return (
        this.statistics !== null &&
        "levels" in this.statistics &&
        Object.keys(this.statistics.levels).length > 0
      );
    },
    hardModeIndicator() {
      return this.status.mode === MODE["HARD"] ? "*" : "";
    },
    hasFavoriteStatistics() {
      return this.favoriteStatistics.length > 0;
    },
    hasOverallStatistics() {
      return this.statisticsAvailable
        ? Object.keys(this.statistics.levels).length > 0
        : false;
    },
    nextPuzzleDay() {
      return new Date(new Date().setHours(24, 0, 0, 0)).getTime();
    },
    todayOptions() {
      if (!this.puzzleCompleted) {
        return [];
      }
      return [
        {
          label: "Level",
          value: this.status.level,
        },
        {
          label: "Mode",
          value: this.status.mode,
        },
      ];
    },
    todayInfo() {
      if (!this.puzzleCompleted) {
        return [];
      }
      let hints = 0;
      if (this.status.hints !== null) {
        hints = this.status.hints.filter(
          (item) => item.revealed === true
        ).length;
      }
      return [
        {
          label: "Solve\nTime",
          value: this.elapsedTimeFormater(this.puzzleTime),
        },
        {
          label: "Sequences\nFound",
          value: this.foundSequencesStr,
        },
        {
          label: "Hints\nUsed",
          value: hints,
        },
      ];
    },
    favoriteStatistics() {
      let stats = [];
      if (this.favoriteLevel !== null) {
        stats.push({
          label: "Level",
          value: this.favoriteLevel,
        });
      }
      if (this.favoriteMode !== null) {
        stats.push({
          label: "Mode",
          value: this.favoriteMode,
        });
      }

      return stats;
    },
    modesAvailable() {
      // check if mode is available for all levels
      const modesAvailable = Object.values(this.statistics.levels).reduce(
        (acc, level) => {
          acc = acc && "mode" in level;
          return acc;
        },
        true
      );
      return modesAvailable;
    },
    overallStatistics() {
      let stats = [
        {
          label: "Games\nCompleted",
          value: Object.keys(this.statistics.levels).reduce(
            (total, lvl) => this.statistics.levels[lvl].gamesCompleted + total,
            0
          ),
        },
        {
          label: "Current\nStreak",
          value: this.statistics.currentStreak,
        },
        {
          label: "Max\nStreak",
          value: this.statistics.maxStreak,
        },
      ];

      return stats;
    },
    favoriteLevel() {
      let maxKeys = [];
      let maxValue = -1;
      for (const key in this.statistics.levels) {
        if (this.statistics.levels[key].gamesCompleted !== undefined) {
          if (this.statistics.levels[key].gamesCompleted > maxValue) {
            maxValue = this.statistics.levels[key].gamesCompleted;
            maxKeys = [key];
          } else if (this.statistics.levels[key].gamesCompleted === maxValue) {
            maxKeys.push(key);
          }
        }
      }
      if (maxKeys.length === 1) {
        return maxKeys[0];
      }
      return null;
    },
    favoriteMode() {
      if (!this.statisticsAvailable || !this.modesAvailable) {
        return null;
      }

      const totalCounts = {};
      Object.values(this.statistics.levels).forEach((level) => {
        const modes = level.mode;
        Object.entries(modes).forEach(([mode, count]) => {
          totalCounts[mode] = (totalCounts[mode] || 0) + count;
        });
      });

      const maxCount = Math.max(...Object.values(totalCounts));

      const maxKeys = Object.keys(totalCounts).reduce((acc, modeStr) => {
        if (totalCounts[modeStr] === maxCount) {
          acc.push(modeStr);
        }
        return acc;
      }, []);
      if (maxKeys.length === 1) {
        return maxKeys[0];
      }
      return null;
    },
    hasLevelStatistics() {
      return this.statisticsAvailable
        ? this.level in this.statistics.levels
        : false;
    },
    selectedLevelStatistics() {
      return Object.keys(this.allLevelStatistics)
        .filter((key) => parseInt(key) === this.level)
        .reduce((obj, key) => {
          obj[key] = this.allLevelStatistics[key];
          return obj;
        }, {});
    },
    allLevelStatistics() {
      // if (!this.statisticsAvailable || !this.modesAvailable) {
      //   return {};
      // }
      return this.levels.reduce((acc, key) => {
        if (key in this.statistics.levels) {
          acc[key] =
            this.statistics.levels[key].gamesCompleted !== 0
              ? [
                  {
                    label: "Fastest\nTime",
                    value: this.elapsedTimeFormater(
                      this.statistics.levels[key].fastestTime
                    ),
                  },
                  {
                    label: "Average\nTime",
                    value: this.elapsedTimeFormater(
                      Math.round(
                        this.statistics.levels[key].totalTime /
                          this.statistics.levels[key].gamesCompleted
                      )
                    ),
                  },
                  {
                    label: "Average\nHints",
                    value:
                      Math.round(
                        (10 * this.statistics.levels[key].hints) /
                          this.statistics.levels[key].gamesCompleted
                      ) / 10,
                  },
                  {
                    label: "Average\nSubmits",
                    value:
                      Math.round(
                        (10 * this.statistics.levels[key].submissions) /
                          this.statistics.levels[key].gamesCompleted
                      ) / 10,
                  },
                  {
                    label: "Games\nCompleted",
                    value: this.statistics.levels[key].gamesCompleted,
                  },
                  {
                    label: "EASY\nMode",
                    value: this.statistics.levels[key].mode[MODE["EASY"]],
                  },
                  {
                    label: "HARD\nMode",
                    value: this.statistics.levels[key].mode[MODE["HARD"]],
                  },
                ]
              : [];
        } else {
          acc[key] = [];
        }
        return acc;
      }, {});
    },
  },
};
</script>

<style scoped>
.stats-flex {
  gap: 0.875vh;
  display: flex;
  flex-direction: column;
}
#container {
  justify-content: center;
}
.stats-box {
  display: flex;
  gap: 0.75vh 3vh;
  justify-content: center;
  align-items: center;
  margin: 0 3vh;
  flex-wrap: wrap;
  flex: 1 0 auto;
}
.stats-cell {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 0.3vh;
  overflow: visible;
}
.stats-cell.break {
  width: 100%;
  flex: 1 0 auto;
}


.stats-chart {
  display: flex;
  flex-direction: column;
  gap: 0.75vh;
}
.stats-chart-row {
  display: flex;
  gap: 0.75vh;
}

.stats-chart-row-label {
  text-align: right;
  font-weight: bold;
  width: 7vh;
}

.stats-chart-bar {
  background: #666;
  padding: 0 1vh;
  position: relative;
}

.bar-highlight {
  background: var(--border-color);
  padding: 0 1vh;
  position: relative;
}

.stats-chart-bar:before {
  content: attr(data-label);
  position: absolute;
  right: 0; /* Align label to the right */
  padding: 0 0.75vh; /* Padding for label */
  color: var(--modal-background-color); /* Text color */
  font-weight: bold;
  white-space: nowrap; /* Prevent text wrap */
}

.stats-img {
  height: 5vh;
}
button {
  height: 6.25vh;
  color: var(--modal-background-color);
  gap: 1.5vh;
}
.archive {
  background: var(--border-color);
  color: var(--modal-background-color);
}

.knotilus-logo img {
  height: 1em;
}

.lvl-stats-container {
  position: relative;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-5vh);
}
h2,
h3 {
  text-align: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}

.fade-leave-active {
  position: absolute;
  left: 0;
  right: 0;
}
.puzzle-time {
  font-weight: bold;
  font-size: 3vh;
  font-family: "Fira Sans", system-ui;
}
#leaderboard {
  border-collapse: collapse;
}
#leaderboard th,
#leaderboard td {
  text-align: center;
  border-bottom: 1px solid var(--primary-color);
  padding: 1vh 0;
}
a.important-note {
  text-decoration: underline;
  color: var(--border-color);
  cursor: pointer;
}
.left {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  width: 50%;
}
.right {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  width: 50%;
}
.middle {
  border-radius: 0;
}

</style>
